<template>
    <b-card-header v-if="sender" class="email-detail-head">
        <div v-if="subject" class="d-flex w-100 mb-1">
            <h4>{{ subject }}</h4>
        </div>
        <div class="user-details d-flex justify-content-between align-items-center flex-wrap">
            <b-avatar
                :text="resolveInitials(sender.name)"
                class="mr-1 cursor-pointer badge-minimal"
                rounded
                size="md"
                variant="tertiary"
            />
            <div class="mail-items">
                <h5 class="mb-0" @click="$emit('expanded', !isExpanded)">
                    {{ sender.name }}
                </h5>

                <template v-if="formattedMetadata">
                    <b-dropdown class="email-info-dropup" no-caret toggle-class="p-0" variant="link">
                        <template #button-content>
                            <span class="font-small-3 text-muted mr-25">
                                {{ sender.identity }}
                            </span>
                            <font-awesome-icon class="text-secondary" icon="angle-down" size="sm" />
                        </template>
                        <table class="table table-sm table-borderless font-small-3">
                            <tbody>
                                <tr v-for="metadata in formattedMetadata">
                                    <td class="text-right text-muted align-top">{{ metadata.name }}:</td>
                                    <td>{{ metadata.value }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </b-dropdown>
                </template>
                <template v-else>
                    <span class="font-small-3 text-muted mr-25">
                        {{ sender.identity.identity }}
                    </span>
                </template>
            </div>
        </div>
        <div class="mail-meta-item d-flex align-items-center">
            <small class="mail-date-time text-muted">
                {{
                    formatDate(entry.time, {
                        month: "numeric",
                        day: "numeric",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                    })
                }}
            </small>

            <b-dropdown class="ml-1" no-caret right toggle-class="p-0" variant="link">
                <template #button-content>
                    <font-awesome-icon class="ml-50 text-body" icon="ellipsis-v" />
                </template>

                <!-- @NOTICE this is not a b-dropdown-item, because that has issues with scrolling to bottom -->
                <li role="presentation">
                    <button
                        class="dropdown-item d-flex align-items-center"
                        role="menuitem"
                        type="button"
                        @click="$emit('load-editor-content')"
                    >
                        <font-awesome-icon icon="arrow-turn-down-left" />
                        <span class="align-middle ml-50">{{ $t("entities.email.reply") }}</span>
                    </button>
                </li>
            </b-dropdown>

            <b-button class="ml-1" variant="flat-secondary" @click="$emit('expanded', !isExpanded)">
                <font-awesome-icon :icon="isExpanded ? 'angle-up' : 'angle-down'" />
            </b-button>
        </div>
    </b-card-header>
</template>

<script>
import { computed } from "@vue/composition-api";
import { BAvatar, BButton, BCardHeader, BDropdown, BDropdownItem, BDropdownItemButton, VBTooltip } from "bootstrap-vue";
import useActiveChatMetadata from "@/composables/useActiveChatMetadata";
import { formatDate } from "@/utils/luxon";
import { resolveInitials } from "@/utils/users";
import { isChatAssignedToMeV21, shouldAssignV21 } from "@/utils/chats";

export default {
    components: {
        BDropdown,
        BDropdownItem,
        BDropdownItemButton,
        BCardHeader,
        BAvatar,
        BButton,
        VBTooltip,
    },
    directives: {
        "b-tooltip": VBTooltip,
    },
    props: {
        activeChat: {
            type: Object,
            required: true,
        },
        entry: {
            type: Object,
            required: true,
        },
        sender: {
            type: Object,
            required: true,
        },
        isExpanded: {
            type: Boolean,
            required: true,
        },
    },
    setup(props) {
        const { formatMetadata } = useActiveChatMetadata();
        const formattedMetadata = formatMetadata(props.entry.metadata);

        const subject = computed(() => {
            return formattedMetadata?.find((metadata) => metadata.name === "subject")?.value ?? "";
        });

        return {
            subject,
            formatDate,
            formattedMetadata,
            resolveInitials,
            shouldAssignV21,
            isChatAssignedToMeV21,
        };
    },
};
</script>
